// src/utils/cloudinaryUpload.js
import imageCompression from 'browser-image-compression';

const compressFile = async (file) => {
    const options = {
        maxSizeMB: 1.2,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
        initialQuality: 0.85
    };
    try {
        return await imageCompression(file, options);
    } catch (err) {
        console.warn('Compress failed, using original:', err);
        return file;
    }
};

const uploadToCloudinary = async (files) => {
    if (!files || files.length === 0) return [];

    const uploaded = [];
    const uploadPreset = 'realestate-upload';
    const cloudName = 'dp9lxlric';

    for (let file of files) {
        file = await compressFile(file);  // ← compress trước

        const formData = new FormData();
        formData.append('file', file);
        formData.append('upload_preset', uploadPreset);
        formData.append('folder', 'properties');

        try {
            const res = await fetch(`https://api.cloudinary.com/v1_1/${cloudName}/image/upload`, {
                method: 'POST',
                body: formData
            });
            const data = await res.json();

            if (data.public_id) {
                uploaded.push({ public_id: data.public_id });  // ← chỉ trả về object có public_id
            }
        } catch (err) {
            console.error('Upload error:', err);
        }
    }

    return uploaded; // mảng [{ public_id: "..." }, ...]
};

export default uploadToCloudinary;